import { useCallback, useState } from 'react';

export function useMasterAndFftParams(initialFftOrder?: number) {
  const [masterVolume, setMasterVolumeState] = useState(1);
  const [masterPlaybackRate, setMasterPlaybackRateState] = useState(1);
  // Default FFT order to 15 (32768) if not provided; do not auto-adjust on visibility.
  const [masterFftOrder, setMasterFftOrder] = useState(() =>
    Math.max(5, Math.min(15, Math.floor(typeof initialFftOrder === 'number' ? initialFftOrder : 15)))
  );
  const [masterFftSmoothing, setMasterFftSmoothing] = useState(0.17);

  const setMasterPlaybackRate = useCallback((r: number) => {
    const v = Math.max(0.5, Math.min(2.0, r));
    setMasterPlaybackRateState(v);
  }, []);

  const setMasterVolume = useCallback((v: number) => {
    // Limit to +6 dB (~1.995x)
    const maxGain = Math.pow(10, 6 / 20);
    const clamped = Math.max(0, Math.min(maxGain, v));
    setMasterVolumeState(clamped);
  }, []);

  return {
    masterVolume, setMasterVolume,
    masterPlaybackRate, setMasterPlaybackRate,
    masterFftOrder, setMasterFftOrder,
    masterFftSmoothing, setMasterFftSmoothing,
  };
}
